export default {
  title: 'Dată și oră',
  buttons: {
    done: 'Gata',
  },
};
